import { Transfer } from 'element-ui'

const YTransfer = Transfer
YTransfer.$depends = [Transfer]
YTransfer.$name = 'y-transfer'
YTransfer._name = 'Transfer 穿梭框'

export default YTransfer
